import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useOutsideClick } from "./useOutsideClick";
import { removeAccents } from "../../helpers/helpers";
import { ServicioCardReserva } from "../cards/ServicioCardReserva";

export const DropdownMultipleServicios = ({ services, selectedServices, handleServicesChanged, editCita = false, variant = 'dropdown', onCardClick, enabledServiceIds = null }) => {
    const { colores } = useSelector(state => state.ui);
    const [isLoaded, setIsLoaded] = useState(false);
    const [visibility, setVisibility] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const dropdownMenuRef = useRef();

    const toggleVisibility = () => setVisibility(!visibility);

    useEffect(() => { setIsLoaded(true); }, []);

    useOutsideClick(dropdownMenuRef, () => setVisibility(!visibility), visibility);

    const isServiceEnabled = (service) => {
        if (!enabledServiceIds || !Array.isArray(enabledServiceIds)) return true;
        const id = service?._id ?? service;
        return id && enabledServiceIds.some(eid => String(eid) === String(id));
    };

    const handleOnChange = (e) => {
        const { value, checked } = e.target;
        const service = services.find(v => v._id === value);
        if (service && !isServiceEnabled(service)) return;
        if (checked) {
            handleServicesChanged([...selectedServices, service]);
        } else {
            handleServicesChanged(selectedServices.filter(v => v._id !== value));
        }
    };

    const isChecked = (service) => selectedServices?.some(v => v._id === service._id);

    const handleToggle = (srv) => {
        if (!isServiceEnabled(srv)) return;
        if (typeof onCardClick === 'function') {
            onCardClick(srv);
        }
        if (isChecked(srv)) {
            handleServicesChanged(selectedServices.filter(ss => String(ss._id) !== String(srv._id)));
        } else {
            handleServicesChanged([...selectedServices, srv]);
        }
    };

    if (variant === 'cards') {
        const filteredBySearch = (services || []).filter((s) => {
            if (!searchQuery.trim()) return true;
            const q = removeAccents(searchQuery.trim().toLowerCase());
            const nombre = removeAccents((s.nombre || '').toLowerCase());
            return nombre.includes(q);
        });
        return (
            <>
                <div className="servicio-search">
                    <input
                        type="text"
                        placeholder="Buscar servicio..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
                <div className="servicios-grid-reserva">
                    {filteredBySearch.map((servicio) => (
                        <ServicioCardReserva
                            key={servicio._id}
                            servicio={servicio}
                            isSelected={isChecked(servicio)}
                            onToggle={handleToggle}
                            disabled={!isServiceEnabled(servicio)}
                        />
                    ))}
                </div>
            </>
        );
    }

    return (
        <div className="brb-select">
            <div
                className={`brb-select-container ${visibility ? 'active' : ''}`}
                onClick={toggleVisibility}
            >            
                <p>{selectedServices.length ? selectedServices.map(v => v.nombre).join(", ") : "Seleccione servicios"}</p>
                <div className="right-zone">
                	<span className="select-arrow select-arrow-down"></span>
                </div>
            </div>
            <div ref={dropdownMenuRef} className={`brb-select-options select-servicio ${visibility ? 'active' : ''}`}>
                {
                    services.map((service) => {
                        const disabled = !isServiceEnabled(service);
                        return (
                        <div key={service._id} className={`brb-select-option ${disabled ? 'brb-select-option--disabled' : ''}`} style={{ backgroundColor: colores.color6 }}>
                            <input type="checkbox" id={service._id} name={service._id} value={service._id} checked={isChecked(service)} onChange={handleOnChange} disabled={disabled} />
                            <label htmlFor={service._id}>{service.nombre}</label>
                        </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
